export const de = {
  accept: 'Akzeptieren',
  RDI: 'RDI',
  percent: 'prozent',
  pageNotFoundTitle: '404 - Seite nicht gefunden',
  pageNotFoundDesc: 'Die gesuchte Seite existiert nicht.',
  contactAdminMessage:
    'Wenn Sie glauben, dass ein Problem vorliegt, wenden Sie sich an den Administrator.',
  age: 'Alter',
  spontaneous: 'spontan',
  userManual: 'Benutzerhandbuch',
  AHI: 'AHI',
  about: 'über',
  for: 'für',
  phone: 'telefon',
  email: 'Email',
  website: 'Webseite',
  delete: 'löschen',
  remove: 'entfernen',
  removeAll: 'alle entfernen',
  removeAllEventsTitle: 'Alle Ereignisse entfernen?',
  removeAllEventsDescription:
    'Sind Sie sicher, dass Sie alle Ereignisse des Typs {eventType} entfernen möchten?',
  deviceInformation: 'Geräteinformationen',
  releaseDate: 'Veröffentlichungsdatum',
  deviceInfoAppliesTo: 'Gilt für Onera SleepMap Version 1.5.0',
  udi: 'UDI',
  deviceInfoDescription:
    'Onera SleepMap ist ein rein softwarebasiertes medizinisches Gerät, das eine automatische Ereigniserkennung für Onera Polysomnographie-Aufzeichnungen ermöglicht.',
  close: 'schließen',
  eventStart: 'Veranstaltungsbeginn',
  resourceNotAvailable: 'Ressource nicht verfügbar',
  oneStudyAtATimeError: 'Sie können jeweils nur eine Schlafstudie öffnen',
  alreadyOpenedByUserError: 'Diese Schlafstudie wurde bereits von einem anderen Benutzer geöffnet',
  studyRightsError: 'Sie haben keine Berechtigung, diese Schlafstudie zu öffnen',
  fetchErrorDescription: 'Fehler beim Abrufen der Hilfe-URL',
  manualErrorDescription: 'Das Handbuch kann nicht geöffnet werden',
  medDeviceInfo: 'Informationen zu medizinischen Geräten',
  durationMin: 'Dauer (Min)',
  durationMinInTST: 'Dauer (min in TST)',
  seconds: ' s',
  duration: 'Dauer',
  time: 'Zeit',
  manualError: 'manueller Fehler',
  fetchError: 'Abruffehler',
  eventType: 'Ereignistyp',
  amountOfSnoringPeriods: 'Anzahl der Schnarchphasen',
  analysisSoftware: 'SleepMap',
  apnea: 'Apnoe',
  studyInformation: 'Studieninformationen',
  studyInformationNote: 'Brustsensor möglicherweise verkehrt herum getragen',
  purpose: 'Zweck',
  studyConfiguration: 'Studienkonfiguration',
  patientInfo: 'Patienteninformationen',
  attention: 'Achtung',
  desaturationPanelLabel: 'Die {desaturation}%-Regel wurde angewendet.',
  browserWarning: {
    versionTitle: 'Browser wird nicht unterstützt',
    versionDescription:
      'Bitte verwenden Sie Edge oder Chrome als Browser und stellen Sie sicher, dass die Version nicht älter als 6 Monate ist.',
    resolutionTitle: 'Die Browserauflösung wird nicht unterstützt',
    resolutionDesctiption:
      'Bitte verwenden Sie die höchste verfügbare Bildschirmauflösung. \n\n Beachten Sie, dass SleepMap eine High Definition (HD)-Auflösung benötigt, um richtig zu funktionieren.'
  },
  analysisService: 'SleepMap',
  obstructiveApnea: 'Apnoe Obstruktiv',
  shortApneaCentral: 'A.Zentral',
  shortApneaObstructive: 'A.Obstruktiv',
  shortApneaMixed: 'A.Gemischt',
  centralApnea: 'Zentrale Apnoe',
  mixedApnea: 'Gemischte Apnoe',
  obstructiveHypopnea: 'Hypopnoe Obstruktiv',
  centralHypopnea: 'Hypopnoe Zentral',
  apneaAndHypopnea: 'Apnoe und Hypopnoe',
  apneaLimit:
    'Apnoe-, Hypopnoe-, Cheyne-Stokes-Atmung und RERA-Ereignisse müssen mindestens 10 Sek. dauern',
  apply: 'Anwenden',
  arousal: 'Weckreaktion',
  recordingTime: 'Aufnahmezeit',
  arousals: 'Erregungen',
  arousalLimit: 'Weckreaktionen müssen mindestens 3 Sek.',
  inWakeStageWarning:
    'Sie können diesen Ereignistyp während der Wachphasen des Schlafs nicht erstellen oder ändern.',
  hasRespiratoryEventTitle: 'In dieser Schlafphase liegt ein respiratorisches Ereignis vor.',
  hasRespiratoryEventWarning: 'Respiratorische Ereignisse sind grau hervorgehoben.',
  approvedDescription:
    'Sind Sie sicher, dass Sie den Status auf <strong>akzeptiert</strong> setzen möchten?',
  arousalTRT: 'Weckreaktion, TRT',
  rule: 'Regel',
  csb: 'CSB',
  trt: 'TRT',
  n1: 'N1',
  n2: 'N2',
  n3: 'N3',
  asterixRespiratory:
    '* Die respiratorische Analyse von Hypopnoen erfolgt gemäß dem AASM Manual for Scoring of Sleep and Associated Events 3.0 (Ausgabe 2023) anhand von ',
  automaticScoreIsDone: 'Automatisches Scoring wird durchgeführt',
  automaticScoreSummary: 'Automatisches Scoring, Zusammenfassung',
  band: 'Bandfilter',
  birthDate: 'Geburtsdatum',
  bmi: 'BMI',
  cancel: 'Abbrechen',
  cardiacSummary: 'Herz Zusammenfassung',
  central: 'Zentral',
  odiDesatHour: 'ODI (desats/Stunde)',
  durationinMinutes: 'Dauer (Min)',
  spO2Quality: 'SpO2-Qualität',
  sound_spl: 'ton SPL',
  heart_rate: 'herzfrequenz',
  spO2SupineQuality: 'SpO2 Rückenlage Qualität',
  spO2Supine: 'SpO2 Rückenlage',
  epochsStaged: '% epochen gestaffelt',
  nasalPressure: 'Nasendruck',
  changeHistory: 'Änderungshistorie',
  count: 'Zählen',
  minutes: 'minuten',
  countEventsInTST: 'Ereignisse zählen (während TST)',
  connectionLostTitle: 'Verbindung unterbrochen',
  connectionLostDescription:
    'Der Server konnte nicht erreicht werden. Bitte überprüfen Sie Ihre Internetverbindung. Das System wird automatisch versuchen, die Verbindung wiederherzustellen.',
  seeGraphs: 'Siehe grafische Dartsellung',
  seeReport: 'Siehe Bericht',
  seeOverview: 'Übersicht anzeigen',
  changeSignalOrder: 'Signalreihenfolge ändern',
  changeVisibility: 'Signal ein-/ausblenden',
  openColorPalette: 'Farbpalette öffnen',
  openShortcutPicker: 'Tastenkürzel festlegen',
  pressAnyKey: 'Taste drücken',
  clearShortcut: 'Tastenkürzel entfernen',
  shortcutReserved: 'Für Schlafstadien reserviert',
  shortcutAlreadyAssigned: 'Bereits {event} zugewiesen',
  analysisStart: 'Analysebeginn',
  analysisStop: 'Analyseende',
  navigateToStudyDetail: 'Zu den Studiendetails',
  remLatency: 'REM-Latenz',
  invalidHour: 'Stunde ungültig',
  dataIntegrity: 'Datenintegrität',
  desaturation: 'Entsättigung',
  desaturationDrop: 'Entsättigungsabfall',
  desaturationEvents: 'Entsättigungsereignisse',
  deviceSerialNumber: 'Geräteseriennummer',
  downloadDraftReport: 'Berichtsentwurf herunterladen',
  downloadReport: 'Bericht herunterladen',
  spo2Mean: 'SpO2-Mittelwert',
  spo2Min: 'SpO2 Mindest',
  cloneScoreSet: 'PSG-Score-Set dupliziert',
  cloneFail: 'Duplizieren fehlgeschlagen',
  cloneScoreSuccess: 'PSG-Score-Set erfolgreich duplizieren',
  allEpochsLoaded: 'Alle Episoden sind geladen',
  epochsLoaded: 'Alle Daten von {epochSize} Epochen geladen',
  method: 'Methode',
  investigationType: 'Untersuchungstyp',
  signalQualitySummary: 'Signalqualität',
  errorAddScoreSetEvents: 'Fehler beim Hinzufügen des Ereignisses',
  desaturationIndexEvtsH: 'Entsättigungs-Index (Er/Std.)',
  desaturationIndexODI: 'Entsättigungs-Index (ODI)',
  ODI: 'ODI',
  PLMI: 'PLMI',
  snoring: 'Schnarchen',
  statTile_sleepLatency: 'Einschlaflatenz',
  statTile_remLatency: 'REM-Latenz',
  statTile_waso: 'WASO',
  statTile_AHI: 'AHI',
  statTile_apneaIndex: 'Apnoe-Index',
  statTile_hypopneaIndex: 'Hypopnoe-Index',
  statTile_minSpO2: 'Min. SpO2',
  statTile_meanSpO2: 'Mittelw. SpO2',
  statTile_ODI: 'ODI',
  statTile_arousalIndex: 'Arousal-Index',
  statTile_PLMI: 'PLMI',
  statTile_snoringDuration: 'Schnarchdauer',
  statTile_spO2Quality: 'SpO2-Qualität',
  statTile_positionQuality: 'Positionsqualität',
  statTile_nasalCannula: 'Nasenkanüle',
  sleepStagesDistribution_notStaged: 'NS',
  sleepStagesDistribution_totalSleepTime: 'Gesamtschlafzeit',
  sleepStagesDistribution_tstTib: 'TST / TIB',
  sleepPosition_title: 'Schlafposition',
  desaturationsDuration: 'Dauer aller Entsättigungen',
  evtsPerHour: 'Ereignisse/Std',
  minAbbr: 'Min',
  errorOverlapLimitDescription:
    'Das Ereignis überschneidet sich mit zu vielen vorhandenen Ereignissen. Bitte versuchen Sie es mit weniger Ereignissen.',
  errorAuthorization:
    'Sie sind nicht autorisiert, diese Studie anzusehen. Bitte kontaktieren Sie den Support, wenn Sie glauben, dass es sich um einen Fehler handelt.',
  errorAddScoreSetEvent: 'Fehler beim Hinzufügen des Ereignisses',
  errorDeleteScoreSetEvent: 'Fehler beim Löschen des Ereignisses',
  errorGeneratingDraftReport: 'Fehler beim Erstellen des Berichtsentwurfs',
  errorGeneratingReport: 'Fehler beim Erstellen des Berichts',
  errorGetHypnogramEvents: 'Fehler beim Abrufen der Hypnogramm-Ereignisse',
  errorGetLegMovementEvents: 'Fehler beim Abrufen der Beinbewegungs-Ereignisse',
  errorGetReport: 'Fehler beim Abrufen des Berichts',
  errorGetScoreSet: 'Fehler beim Abrufen des Score-Sets',
  errorGetScoreSetEvents: 'Fehler beim Abrufen der Score-Set-Ereignisse',
  errorGetReleaseNotes: 'Fehler beim Laden der Versionshinweise',
  errorAcknowledgeReleaseNotes: 'Fehler beim Bestätigen der Versionshinweise',
  errorGetScoreSets: 'Fehler beim Abrufen der Score-Set-Liste',
  errorGetSignalData: 'Fehler beim Abrufen der Signaldaten',
  errorGetStudies: 'Fehler beim Abrufen der Studien',
  errorGetStudy: 'Fehler beim Abrufen der Studie',
  errorSettingFullNightSignals: 'Fehler beim Einstellen der Signale für die ganze Nacht',
  errorSettingFullNightSignalsMessage:
    'Sie können bis zu 4 Signale auswählen und diese für die ganze Nacht anzeigen!',
  errorUpdateScoreSet: 'Fehler beim Aktualisieren des PSG-Score-Sets',
  errorUpdateScoreSetEvent: 'Fehler beim Aktualisieren des Ereignisses',
  errorUpdateUser: 'Fehler beim Aktualisieren des Benutzers',
  genericAccessError: 'Zugriff ist nicht erlaubt',
  genericAccessErrorPreparingDescription:
    'Sie können auf diese Ressource nicht zugreifen, solange die Studie sich im Status PREPARING befindet.',
  firstName: 'Vorname',
  warningEventLimit: 'Bitte warten, bis die anderen Ereignisänderungen angewandt wurden',
  warningEventLimitDescription:
    'Sie haben 20 Ereignisse nacheinander hinzugefügt oder aktualisiert.',
  frontalEEGElectrodes: 'Frontale EEG-Elektroden',
  fullNightSignals: 'Signale für die ganze Nacht',
  selectSignals: 'Signale auswählen',
  fullSignal: 'Volles Signal',
  name: 'Name',
  dateOfBirth: 'Geburtsdatum',
  patientID: 'Patienten-ID',
  studyID: 'Studien-ID',
  unitSystem: 'Einheitensystem',
  METRIC: 'Metrisch',
  IMPERIAL: 'Imperial',
  reportProgressBar: {
    header: 'Einen Moment bitte',
    description: 'Schlafbericht wird erstellt ...'
  },
  gender: 'Geschlecht',
  Arrhythmia: 'Arrhythmie',
  'Sinus Tachycardia': 'Sinustachykardie',
  'Sinus Bradycardia': 'Sinusbradykardie',
  arrhythmias: 'Arrhythmien',
  arrhythmiaSummary: 'Arrhythmie Zusammenfassung',
  atrialFibrillation: 'Vorhofflimmern',
  narrowComplexTachycardia: 'Schmalkomplextachykardie',
  wideComplexTachycardia: 'Breitkomplextachykardie',
  keyHr: 'Schlüssel-HF',
  timeInMin: 'Zeit (min)',
  avgHrLabel: 'Mittl.:',
  highestHrLabel: 'Höchst.:',
  avBlocks: 'AV-Blöcke',
  pacemakerRhythm: 'Schrittmacherrhythmus',
  asystole: 'Asystolie',
  otherIrregularBeats: 'Andere unregelmäßige Schläge',
  pvcs: 'VES',
  pacs: 'SVES',
  longestPause: 'Längste Pause',
  bruxism: 'Bruxismus',
  bruxismSummary: 'Bruxismus Zusammenfassung',
  phasic: 'Phasisch',
  tonic: 'Tonisch',
  bruxismType: 'Typ',
  percentTotal: '% gesamt',
  avgDurSec: 'Mittl. Dauer(s)',
  minDurSec: 'Min. Dauer(s)',
  maxDurSec: 'Max. Dauer(s)',
  totalTimeMin: 'Gesamtzeit (min)',
  arrhythmiaEvents: 'Arrhythmie-Ereignisse',
  arrhythmiaLayoutWarning:
    'Dies ist ein neues Layout im Vergleich zum gespeicherten technischen PDF-Report',
  'Atrial Fibrillation': 'Vorhofflimmern',
  PAC: 'SVES',
  PVC: 'VES',
  AV_Block: 'AV-Block',
  'Pacemaker Rhythm': 'Schrittmacherrhythmus',
  'Other Arrhythmia': 'Andere Arrhythmie',
  Asystole: 'Asystolie',
  'Narrow Complex Tachycardia': 'Schmalkomplextachykardie',
  'Wide Complex Tachycardia': 'Breitkomplextachykardie',
  generateDraftReport: 'Berichtsentwurf erstellen',
  generateReport: 'Bericht erstellen',
  heartRateMean: 'Herzfrequenz, Mittelwert',
  heartRateMax: 'Herzfrequenz, Höchstwert',
  heartRateSummary: 'Herzfrequenz Zusammenfassung',
  hrDistributionDuringSleep: 'HF-Verteilung während des Schlafs',
  cardiacEvents: 'Kardiale Ereignisse',
  sinusBradycardia: 'Sinusbradykardie',
  sinusTachycardia: 'Sinustachykardie',
  lowestHrLabel: 'Niedrigste:',
  event: 'Ereignis',
  indexInSleepEvtsH: 'Index im Schlaf (Err./h)',
  height: 'Größe',
  bpm: 'BPM',
  home: 'Home',
  hypopnea: 'Hypopnoe',
  index: 'Index',
  indexOfEventsPerHour: 'Index (Ereignisse/Stunde)',
  HR: 'HR',
  hideSignal: 'Signal ausblenden',
  indexOfHR: 'Index HR',
  inReview: 'Wird überprüft',
  inReviewDescription:
    'Sind Sie sicher, dass Sie den Status auf <strong>In Prüfung</strong> setzen möchten?',
  lastName: 'Nachname',
  left: 'Links',
  legMovementLimit:
    'Beinbewegungen müssen mindestens 0,5 Sek., aber nicht länger als 10 Sek. dauern',
  legSensorPosition: 'Beinsensor-Position',
  lightsLimit:
    'Ein Ereignis kann nicht vor dem Licht-aus-Zeitstempel beginnen und nicht nach Licht an enden',
  lightsOff: 'Licht aus',
  lightsOn: 'Licht an',
  loading: 'Laden',
  maximum: 'Höchstwert',
  max: 'Max.',
  mean: 'Mittelwert',
  rem: 'REM',
  nrem: 'NREM',
  measurementEnd: 'Messende',
  measurementStart: 'Messbeginn',
  spontaneus: 'Spontaneus',
  mild: 'leicht',
  minimum: 'Mindestwert',
  mixed: 'Gemischt',
  moderate: 'moderat',
  movementEvents: 'Bewegungsereignisse',
  movementPosition: 'Bewegung und Position',
  no: 'Nein',
  noData: 'Keine Daten verfügbar!',
  ok: 'OK',
  notch: 'Kerbfilter (Notch)',
  lowCutTooltip: 'Low Cut / Hochpass',
  highCutTooltip: 'High Cut / Tiefpass',
  note: 'Hinweis',
  sleepStudyRequestNote: 'Hinweis zur Schlafstudienanforderung',
  notUsed: 'Nicht verwendet',
  normal: 'Normal',
  number: 'Anzahl',
  numberOfEpisodes: 'Anzahl der Episoden',
  obstructive: 'Obstruktiv',
  oxygen: 'Sauerstoff',
  oxygenSummary: 'Sauerstoff Zusammenfassung',
  eventsDurationFetchError: 'Fehler beim Abrufen der Diagrammdaten',
  eventsDurationFetchErrorDescription:
    'Fehler beim Abrufen von Ereignissen im Ereignisdauerdiagramm',
  foreignPatientId: 'Patient/innen-ID',
  patientId: 'Patient/innen-ID',
  patientApplied: 'Angebracht durch Patient/in',
  percentage: 'Prozentsatz',
  percentageOfSleepTime: '% der Schlafzeit',
  percentageTimeBetween: '% Zwischenzeit',
  percentOfTST: 'Prozent der TST',
  percentTST: '% TST',
  physician: 'Ärztin/Arzt',
  waso: 'WASO',
  physicianNote: 'Hinweis der Ärztin/ des Arztes',
  physicianResult: 'Ergebnis der Ärztin/ des Arztes',
  physicianReview: 'Ärztliche Beurteilung',
  PLM: 'PLM',
  plms: 'PLMS',
  plmsIndex: 'PLM-Index',
  Diagnostic: 'Diagnostisch',
  TherapyControl: 'Therapiekontrolle',
  CPAP: 'PAP',
  MRA: 'UKPS',
  Implant: 'HNS',
  'Positional Device': 'Positionsgerät',
  Medication: 'Medikamente',
  Other: 'Andere',
  'Insomnia Disorder': 'Schlaflosigkeitsstörung',
  OSA: 'OSA',
  Narcolepsy: 'Narkolepsie',
  RLS: 'RLS',
  'Circadian Rhythm Sleep-Wake Disorders': 'Schlaf-Wach-Rhythmusstörungen',
  Unknown: 'Unbekannt',
  emgLeg: 'EMG Bein',
  ecg: 'EKG',
  nasal_pressure: 'Nasendruck',
  resp_flow: 'Atemfluss',
  resp_effort: 'Atemanstrengung',
  emg_leg: 'EMG Bein',
  activity: 'Aktivität',
  signalWithoutArtifacts: 'Prozentsatz des Signals ohne Artefakte an der Gesamtaufzeichnungszeit',
  position: 'Position',
  artifact: 'Artefakt',
  plmsIndexWithArousals: 'PLM-Index mit Weckreaktionen (Arousal)',
  positionStatistics: 'Positionsstatistik',
  preset: 'Voreinstellung',
  presetName: 'Namen voreinstellen',
  defaultPresetOverwriteTitle: 'Die Standardvoreinstellung kann nicht überschrieben werden',
  defaultPresetOverwriteDescription:
    'Bitte geben Sie einen neuen Voreinstellungsnamen ein, um Ihre Änderungen zu speichern.',
  prone: 'Bauchlage',
  psgReport: 'PSG-Bericht',
  recordingEnd: 'Aufzeichnungsende',
  recordingStart: 'Aufzeichnungsbeginn',
  reject: 'Ablehnen',
  report: 'Bericht',
  rejectedDescription:
    'Sind Sie sicher, dass Sie den Status auf <strong>abgelehnt</strong> setzen möchten?',
  reportPage: 'Seite {current}/{total}',
  reportPageRef: 'Seite {page}',
  reportSignedBy: 'Bericht unterzeichnet von',
  reportStatus: 'Berichtsstatus: {status}',
  reportVersion: 'T: {template} von M: {mock}',
  RERA: 'RERA',
  invalidDate: 'ungültiges datum',
  rescore: 'Scoring wiederholen',
  upright: 'aufrecht',
  nonsupine: 'nicht-supine',
  totalLegMovements: 'Gesamte Beinbewegungen',
  respiratoryEventsHourOfTST: 'Respiratorische Ereignisse / Stunde des TST',
  respiratory: 'Atmung',
  indexOfEvtsPerHour: 'Index (Er/Std.)',
  respiratoryEvents: 'Respiratorische Ereignisse',
  respiratoryEventsDuringSleep: 'Resp. Ereign. im Schlaf',
  respiratoryEventsInTST: 'Respiratorische Ereignisse (in TST)',
  respiratorySummary: 'Respiratory Zusammenfassung',
  respiratoryParams: 'Atmung Parameter',
  right: 'Rechts',
  saturation: 'Sättigung',
  save: 'Speichern',
  saveLaneHeightsDescription:
    'Möchten Sie die neuen Signalspurhöhen in der aktuellen Voreinstellung speichern?',
  saveLaneHeightsTitle: 'Spurhöhen speichern?',
  savingNote: 'Hinweise speichern',
  savingNoteDescription: 'Sind Sie sicher, dass Sie die Hinweise speichern möchten?',
  scoring: 'Punktevergabe',
  scoringResult: 'Scoring-Ergebnis',
  scoringResultSet: 'Scoring-Ergebnis einstellen',
  sectionOxygen: 'Sauerstoff',
  selectPreset: 'Voreinstellung auswählen',
  settings: 'Einstellungen',
  severe: 'schwer',
  signalLaneHeight: 'Signalspurhöhe (px)',
  pinLaneHeight: 'Diese Höhe fixieren',
  unpinLaneHeight: 'Lösen (automatische Höhe verwenden)',
  sleep: 'Schlaf',
  spo2: 'SpO2',
  tst: 'TST',
  sleep_stages: 'Schlafstadien',
  eeg_frontal_l: 'EEG frontal L',
  eeg_frontal_r: 'EEG frontal R',
  eog_l: 'EOG L',
  eog_r: 'EOG R',
  moveForward: 'Weiter',
  movePrevious: 'Zurück',
  pause: 'Pause',
  fastBackward: 'Automatische Navigation rückwärts starten',
  fastForward: 'Automatische Navigation vorwärts starten',
  emg_mass_l: 'EMG Masse L',
  emg_mass_r: 'EMG Masse R',
  sensorLikelyWornUpsideDownDescription:
    'Sensor wahrscheinlich verkehrt herum abgenutzt. Positionssignale können falsch sein.',
  supine: 'Rückenlage',
  nonSupine: 'Nicht in Rückenlage',
  remSupine: 'REM + Rücken',
  sleepEfficiency: 'Schlafeffizienz',
  sleepLatency: 'Schlaflatenz',
  sleepSummary: 'Schlafzusammenfassung',
  snore: 'Schnarchen',
  snoreAndCardiac: 'Schnarchen und Herzparameter',
  snoringSummary: 'Schnarchen Zusammenfassung',
  studyId: 'Studien-ID',
  warningViewOnlyTitle: 'View-Only Modus aktiv',
  warningViewOnlyDescription:
    'Diese Studie befindet sich im View-Only Modus. Einige Funktionen sind eingeschränkt und derzeit nicht verfügbar.',
  warningEventUpdateBlocked: 'Aktualisierung des PSG Score Set-Ereignisses eingeschränkt',
  warningEventUpdateBlockedDescription:
    'Die Aktualisierung des PSG Score Set-Ereignisses ist in diesem Modus eingeschränkt',
  warningOverlappingEvents: 'Ereignisüberschneidung nicht erlaubt.',
  overlappingEventsNotPossible: 'Sie können keine überschneidende Ereignisse planen.',
  warningOriginalStudy: 'Es wird versucht ein Original-PSG-Score-Set zu bearbeiten',
  successAddScoreSetEvent: 'Das PSG-Score-Set-Ereignis wurde hinzugefügt',
  successDeleteScoreSetEvent: 'Das PSG-Score-Set-Ereignis wurde gelöscht',
  successUpdateScoreSet: 'Das PSG-Score-Set wurde aktualisiert',
  successUpdateScoreSetEvent: 'Das PSG-Score-Set-Ereignis wurde aktualisiert',
  techApplied: 'Angebracht durch Fachpersonal',
  technician: 'Auswerter/in',
  technicianNote: 'Hinweis der Auswerterin/ des Auswerters',
  technicianResult: 'Ergebnis der Auswerterin/ des Auswerters',
  temporaryReport: 'Berichtsentwurf',
  timeOfSingleSnore: 'Zeit eines einzelnen Schnarchereignisses',
  total: 'Gesamt',
  periodicLegMovement: 'Periodische Beinbewegungen',
  legMovement: 'Beinbewegungen',
  totalAmountOfEvents: 'Gesamtzahl der Ereignisse',
  totalLengthOfEvents: 'Gesamtdauer der Ereignisse',
  totalLengthOfSnoringPeriods: 'Gesamtdauer der Schnarchphasen',
  totalMeasurementTime: 'Gesamte Messdauer',
  totalRecording: 'Gesamte Aufzeichnung',
  totalTime: 'Gesamtzeit',
  trends: 'Trends',
  unscorable: 'Scoring nicht möglich',
  notApplicable: 'N/A',
  unscorableDescription:
    'Sind Sie sicher, dass Sie den Status auf <strong>Scoring nicht möglich</strong> setzen möchten?',
  minimumEventDurationLimit: '{eventType} muss mindestens {duration}s lang sein',
  used: 'Verwendet',
  version: 'Version',
  wake: 'Wach',
  weight: 'Gewicht',
  yes: 'Ja',
  increaseZoom: 'Vergrößern',
  decreaseZoom: 'Verkleinern',
  moveUp: 'Nach oben bewegen',
  moveDown: 'Nach unten bewegen',
  fitToPane: 'An Fenster anpassen',
  fitAllToPane: 'Alles an Fenster anpassen',
  resetToDefault: 'Auf Standardeinstellungen zurücksetzen',
  resetAllToDefault: 'Alles auf Standardeinstellungen zurücksetzen',
  reset: 'Zurücksetzen',
  resetLaneHeights: 'Signalspurhöhen zurücksetzen',
  overflowSignal: 'Signal überlaufen lassen',
  clipSignal: 'Signal beschneiden',
  overflow: 'Überlauf',
  allSignals: 'Alle',
  noSignals: 'Keine',
  filters: 'Filter',
  display: 'Anzeige',
  signals: 'Signale',
  sleepStaging: 'Schlafstadien',
  sleepStagingKeysFixed: 'Tasten fest. 30-s-Ansicht schaltet automatisch weiter.',
  shortcutFixed: 'Fest — nicht konfigurierbar',
  events: 'Ereignisse',
  eventNotFound: 'Ereignis nicht gefunden',
  missingWidget: 'Fehlendes Widget: ',
  durationSec: 'Dauer (s)',
  'Apnea Mixed': 'Apnoe Gemischt',
  'Apnea Central': 'Apnoe-Zentrale',
  'Apnea Obstructive': 'Apnoe Obstruktiv',
  'Hypopnea Obstructive': 'Hypopnoe Obstruktiv',
  'Hypopnea Central': 'Hypopnoe Zentral',
  'Cheyne-Stokes Breathing': 'Cheyne-Stokes-Atmung',
  Snoring: 'Schnarchen',
  Desaturation: 'Entsättigung',
  fourPercentRuleSummary: 'Zusammenfassung der 4%-Regel',
  desaturationRuleSummary: 'Zusammenfassung der 4%-Regel',
  desaturationRuleDescription:
    'Basierend auf Ereignissen, die das 4%-Desaturationskriterium erfüllen',
  'Arousal EEG_frontal_L': 'Erregung',
  'Arousal EEG_frontal_R': 'Erregung',
  'Leg Movement': 'Bewegung der Beine',
  'Periodic Leg Movement': 'Periodische Beinbewegung',
  noHypnogramDataTitle: 'Es gibt keine Daten für diese Hypnogrammkarte.',
  noScoreSetPlaceholder: 'Kein Notensatz ausgewählt. Sie sehen eine unbewertete Studie.',
  'Apnea Mixed Resp_flow': 'Apnoe Gemischt',
  'Apnea Central Resp_flow': 'Apnoe-Zentrale',
  'Apnea Obstructive Resp_flow': 'Apnoe Obstruktiv',
  'Hypopnea Obstructive Resp_flow': 'Hypopnoe Obstruktiv',
  'Hypopnea Central Resp_flow': 'Hypopnoe Zentral',
  'RERA Resp_flow': 'RERA',
  Bruxism_Tonic_L: 'Bruxismus Tonisch',
  Bruxism_Tonic_R: 'Bruxismus Tonisch',
  Bruxism_Mix_L: 'Bruxismus Gemischt',
  Bruxism_Mix_R: 'Bruxismus Gemischt',
  Bruxism_Phasic_L: 'Bruxismus Phasisch',
  Bruxism_Phasic_R: 'Bruxismus Phasisch',
  systemIdentificationInformation:
    'Hoch komplexe diagnostische unbeaufsichtigte Polysomnographie-Schlafuntersuchung zu Hause durchgeführt. Die Aufzeichnung umfasst EEGx2, EOGx2, EMGx2, EKG mit Herzfrequenz, Nasendruckmessung, Thoraxanstrengung, Bioimpedanzmessung, SpO2, Körperposition, Schnarchmikrofon, Beinmuskelaktivität EMG und Bewegungsaktivitätsmessung. Die gesammelten Daten wurden gemäß den aktuellen Kriterien der American Academy of Sleep Medicine unter Verwendung der {}%-Regel in 30-Sekunden-Epochen ausgewertet \n',
  systemIdentificationInformationTherapyControl:
    'Der Zweck der Schlafuntersuchung besteht darin, die Wirksamkeit der {}-Therapie zu ermitteln. \n',
  systemIdentificationInformationVersion:
    'Die Daten wurden mit Onera STS {} aufgezeichnet und mit SleepMap {} analysiert.',
  unstaged: 'Uninszeniert',
  reportSection: 'Abschnitt Bericht',
  heartRateBPM: 'Herzfrequenz (BPM)',
  1000: 'Studien-ID konnte nicht gefunden werden',
  1001: 'Benutzer-ID konnte nicht gefunden werden',
  1002: 'Studien-ID konnte nicht gefunden werden',
  1003: 'Sie haben keine Studie geöffnet',
  1004: 'Sie müssen diese Studie erneut öffnen',
  1005: 'Sie haben bereits eine andere Studie geöffnet',
  1006: 'Diese Studie wurde bereits von einem anderen Benutzer geöffnet',
  'OCELOT I': 'Onera STS Screener',
  'OCELOT II': 'Onera STS PSG Lite',
  'OCELOT III': 'Onera STS PSG',
  'OCELOT IV': 'Onera STS Screener +',
  'OCELOT V': 'Onera STS PSG Lite +',
  'OCELOT VI': 'Onera STS PSG +',
  'OCELOT VII': 'Onera STS Head',
  'OCELOT VIII': 'Onera STS Leg',
  'OCELOT IX': 'Onera STS Flow',
  'OCELOT X': 'Onera STS PSG+ and PAP',
  C: 'Onera STS Screener',
  HC: 'Onera STS PSG Lite',
  HCLL: 'Onera STS PSG',
  CF: 'Onera STS Screener +',
  HCF: 'Onera STS PSG Lite +',
  HCFLL: 'Onera STS PSG +',
  H: 'Onera STS Head',
  LL: 'Onera STS Leg',
  F: 'Onera STS Flow',
  invertPolarity: 'Polarität umkehren',
  reviewingTechnicianName: 'Name des überprüfenden Technikers',
  reviewingTechnicianCertifications: 'Zertifizierungen',
  technicianName: 'Name des Technikers',
  technicianCertifications: 'Techniker-Zertifizierungen',
  top: 'Oben',
  bottom: 'Unten',
  preferredView: 'Bevorzugte Ansicht',
  preferredView_overview: 'Übersicht',
  preferredView_report: 'Bericht',
  preferredView_graphs: 'Grafische Darstellung',
  viewMode: 'Ansichtsmodus',
  singleView: 'Einzelansicht',
  splitScreen: 'Geteilter Bildschirm',
  singleHypnogram: 'Einzelnes Hypnogramm',
  releaseNotesTitle: 'Neuigkeiten in Onera SleepMap?',
  releaseNotesBrowseTitle: 'Versionshinweise',
  releaseNotesIfuHint:
    'Die vollständige aktualisierte Gebrauchsanweisung finden Sie im Hilfebereich.',
  releaseNotesReleasedOn: 'Veröffentlicht am {date}',
  releaseNotesGotIt: 'Verstanden',
  releaseNotesLoadOlder: 'Ältere Versionen laden',
  releaseNotesSeeMore: 'Weitere Versionen anzeigen'
};
